export const AUTH_URL = `/api/auth`;
